<template>
     <div class="login-content">
        <div class="logoContainer">
            <div class="logo">
                <img src="../../static/logo1.png" alt="">
                <span>云销客</span>
            </div>

            <div class="leftContainer">
                <a-tabs default-active-key="1">
                    <a-tab-pane key="1" tab="创建企业">
                        <div class="register-form">
                            <a-input placeholder="请输入企业名称（必填）" v-model="cname"></a-input>
                            <a-cascader :field-names="{ label: 'name', value: 'id',children:'children'}" change-on-select  :options="options" :load-data="loadData"  placeholder="请选择企业地区（必填）" @change="onChange" />
                            <a-input placeholder="请输入您的名字（必填）" v-model="name"></a-input>

                            <a-button type="primary" @click="establish" shape="round">立即创建</a-button>
                        </div>
                    </a-tab-pane>
                    <!-- <a-tab-pane key="2" tab="加入企业" force-render>
                        Content of Tab Pane 2
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="你的企业">
                        Content of Tab Pane 3
                    </a-tab-pane> -->
                </a-tabs>
            </div>
        </div>
        
        <div class="rightContainer"></div>
    </div>
</template>
<style>
    .ant-tabs-content{
        margin-top: 30px
    }
</style>

<script>
export default {
    data(){
        return{
            options:[],
            value:"",
            name:"",
            cname:""
        }
    },
    mounted(){
        this.$axios.get('/api/getareabypid',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                res.data.data.forEach(item => {
                    this.$set(item,'isLeaf',false)

                })
                this.options=res.data.data
            }
        })
        // this.loadData()
    },
    methods:{
        onChange(value){
           this.value=value
        },
        loadData(selectedOptions) {

            const targetOption = selectedOptions[selectedOptions.length - 1];
            var id;
            if(this.value.length==1){
                id=this.value[0]
            }else{
                id=this.value[1]
            }
            this.$axios.get('/api/getareabypid',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    pid:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    if(this.value.length==1){
                        res.data.data.forEach(item => {
                        this.$set(item,'isLeaf',false)
                        })
                    }
                    targetOption.children = res.data.data
                    this.options = [...this.options];
                }
            })
        },
        establish(){
            var params=new URLSearchParams()
            params.append('province_id',this.value[0])
            params.append('city_id',this.value[1])
            params.append('district_id',this.value[2])
            params.append('company_name',this.cname)
            params.append('name',this.name)
            this.$axios.post('/api/realname',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$router.push({ path:'/'  })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/register.vue